angular.module('zc.projects')

.directive 'zcIncentiveDetail', ->
  restrict: 'E'
  templateUrl: "/templates/projects.incentives/incentive_detail.html"
  scope:
    incentive: "="



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.incentives/incentive_detail.directive.coffee